import "core-js/modules/es6.regexp.split";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import userQuery from '~/graphql/user/me.gql';
import profileQuery from '~/graphql/user/profile.gql';
import ordersQuery from '~/graphql/user/orders.gql';
import orderBl from '~/graphql/user/orderBl.gql';
import orderQuery from '~/graphql/user/order.gql';
import addressesQuery from '~/graphql/user/address/addresses.gql';
import createUserAddressQuery from '~/graphql/user/address/createUserAddress.gql';
import consultedProductsQuery from '~/graphql/user/consultedProducts.gql';
import updateUserAddressMutation from '~/graphql/user/address/updateUserAddress.gql';
import updateUserInformationMutation from '~/graphql/user/updateUserInformation.gql';
import updateUserPasswordMutation from '~/graphql/user/updateUserPassword.gql';
import discountsQuery from '~/graphql/user/discounts.gql';
import updateUserOptinMutation from '~/graphql/user/updateUserOptin.gql';
import deleteUserAddressQuery from '~/graphql/user/address/deleteUserAddress.gql';
import subscribeToNewsletterMutation from '~/graphql/user/newsletter.gql';
import isValidToken from '~/helpers/connection-helper';

function fetchUser(_x) {
  return _fetchUser.apply(this, arguments);
}

function _fetchUser() {
  _fetchUser = _asyncToGenerator(function* (context) {
    if (isValidToken()) {
      const locale = context.state.i18n.currentLocale.iso;
      const response = yield context.app.apolloProvider.defaultClient.query({
        fetchPolicy: 'network-only',
        query: userQuery,
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        },
        variables: {
          locale
        }
      });
      return response.data;
    }

    return null;
  });
  return _fetchUser.apply(this, arguments);
}

function fetchUserProfile(_x2) {
  return _fetchUserProfile.apply(this, arguments);
}

function _fetchUserProfile() {
  _fetchUserProfile = _asyncToGenerator(function* (context) {
    if (isValidToken()) {
      const response = yield context.app.apolloProvider.defaultClient.query({
        fetchPolicy: 'network-only',
        query: profileQuery,
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        }
      });
      return response.data;
    }

    return null;
  });
  return _fetchUserProfile.apply(this, arguments);
}

function fetchUserOrders(_x3) {
  return _fetchUserOrders.apply(this, arguments);
}

function _fetchUserOrders() {
  _fetchUserOrders = _asyncToGenerator(function* (context) {
    if (isValidToken()) {
      const locale = context.state.i18n.currentLocale.iso;
      const response = yield context.app.apolloProvider.defaultClient.query({
        fetchPolicy: 'network-only',
        query: ordersQuery,
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        },
        variables: {
          locale
        }
      });
      return response.data;
    }

    return null;
  });
  return _fetchUserOrders.apply(this, arguments);
}

function fetchUserBL(_x4, _x5, _x6) {
  return _fetchUserBL.apply(this, arguments);
}

function _fetchUserBL() {
  _fetchUserBL = _asyncToGenerator(function* (context, offset, limit) {
    if (isValidToken()) {
      const locale = context.state.i18n.currentLocale.iso;
      const response = yield context.app.apolloProvider.defaultClient.query({
        fetchPolicy: 'network-only',
        query: orderBl,
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        },
        variables: {
          offset,
          limit,
          locale
        }
      });
      return response.data;
    }

    return null;
  });
  return _fetchUserBL.apply(this, arguments);
}

function fetchUserOrder(_x7, _x8) {
  return _fetchUserOrder.apply(this, arguments);
}

function _fetchUserOrder() {
  _fetchUserOrder = _asyncToGenerator(function* (context, reference) {
    if (isValidToken()) {
      const locale = context.state.i18n.currentLocale.iso;
      const response = yield context.app.apolloProvider.defaultClient.query({
        fetchPolicy: 'network-only',
        query: orderQuery,
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        },
        variables: {
          reference,
          locale
        }
      });
      return response.data;
    }

    return null;
  });
  return _fetchUserOrder.apply(this, arguments);
}

function fetchUserConsultedProducts(_x9) {
  return _fetchUserConsultedProducts.apply(this, arguments);
}

function _fetchUserConsultedProducts() {
  _fetchUserConsultedProducts = _asyncToGenerator(function* (context) {
    if (isValidToken()) {
      const locale = context.getters['i18n/locale'].iso;
      const profileId = context.$cookies.get('eb-profile') ? context.$cookies.get('eb-profile').split(':')[0] : '';
      const response = yield context.app.apolloProvider.defaultClient.query({
        fetchPolicy: 'network-only',
        query: consultedProductsQuery,
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        },
        variables: {
          locale,
          profileId
        }
      });
      return response.data;
    }

    return null;
  });
  return _fetchUserConsultedProducts.apply(this, arguments);
}

function fetchUserAddresses(_x10) {
  return _fetchUserAddresses.apply(this, arguments);
}

function _fetchUserAddresses() {
  _fetchUserAddresses = _asyncToGenerator(function* (context) {
    if (isValidToken()) {
      const response = yield context.app.apolloProvider.defaultClient.query({
        fetchPolicy: 'network-only',
        query: addressesQuery,
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        }
      });
      return response.data;
    }

    return null;
  });
  return _fetchUserAddresses.apply(this, arguments);
}

function deleteUserAddress(_x11, _x12, _x13) {
  return _deleteUserAddress.apply(this, arguments);
}

function _deleteUserAddress() {
  _deleteUserAddress = _asyncToGenerator(function* (context, addressType, addressAlias) {
    if (isValidToken()) {
      const response = yield context.app.apolloProvider.defaultClient.mutate({
        mutation: deleteUserAddressQuery,
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        },
        variables: {
          addressType,
          addressAlias
        }
      });
      return response.data;
    }

    return null;
  });
  return _deleteUserAddress.apply(this, arguments);
}

function createUserAddress(_x14, _x15) {
  return _createUserAddress.apply(this, arguments);
}

function _createUserAddress() {
  _createUserAddress = _asyncToGenerator(function* (context, address) {
    if (isValidToken()) {
      const response = yield context.app.apolloProvider.defaultClient.mutate({
        mutation: createUserAddressQuery,
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        },
        variables: {
          address
        }
      });
      return response.data;
    }

    return null;
  });
  return _createUserAddress.apply(this, arguments);
}

function updateUserAddress(_x16, _x17, _x18) {
  return _updateUserAddress.apply(this, arguments);
}

function _updateUserAddress() {
  _updateUserAddress = _asyncToGenerator(function* (context, addressId, address) {
    if (isValidToken()) {
      const response = yield context.app.apolloProvider.defaultClient.mutate({
        mutation: updateUserAddressMutation,
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        },
        variables: {
          addressId,
          address
        }
      });
      return response.data;
    }

    return null;
  });
  return _updateUserAddress.apply(this, arguments);
}

function updateUserInformation(_x19, _x20) {
  return _updateUserInformation.apply(this, arguments);
}

function _updateUserInformation() {
  _updateUserInformation = _asyncToGenerator(function* (context, user) {
    if (isValidToken()) {
      const response = yield context.app.apolloProvider.defaultClient.mutate({
        mutation: updateUserInformationMutation,
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        },
        variables: {
          user
        }
      });
      return response.data;
    }

    return null;
  });
  return _updateUserInformation.apply(this, arguments);
}

function updateUserPassword(_x21, _x22, _x23) {
  return _updateUserPassword.apply(this, arguments);
}

function _updateUserPassword() {
  _updateUserPassword = _asyncToGenerator(function* (context, oldPassword, newPassword) {
    if (isValidToken()) {
      const response = yield context.app.apolloProvider.defaultClient.mutate({
        mutation: updateUserPasswordMutation,
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        },
        variables: {
          oldPassword,
          newPassword
        }
      });
      return response.data;
    }

    return null;
  });
  return _updateUserPassword.apply(this, arguments);
}

function fetchDiscounts(_x24) {
  return _fetchDiscounts.apply(this, arguments);
}

function _fetchDiscounts() {
  _fetchDiscounts = _asyncToGenerator(function* (context) {
    if (isValidToken()) {
      const locale = context.state.i18n.currentLocale.iso;
      const response = yield context.app.apolloProvider.defaultClient.query({
        fetchPolicy: 'network-only',
        query: discountsQuery,
        variables: {
          locale
        },
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        }
      });
      return response.data;
    }

    return null;
  });
  return _fetchDiscounts.apply(this, arguments);
}

function updateUserOptin(_x25, _x26) {
  return _updateUserOptin.apply(this, arguments);
}

function _updateUserOptin() {
  _updateUserOptin = _asyncToGenerator(function* (context, input) {
    if (isValidToken()) {
      const response = yield context.app.apolloProvider.defaultClient.mutate({
        mutation: updateUserOptinMutation,
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        },
        variables: {
          input
        }
      });
      return response.data;
    }

    return null;
  });
  return _updateUserOptin.apply(this, arguments);
}

function subscribeToNewsletter(_x27, _x28, _x29) {
  return _subscribeToNewsletter.apply(this, arguments);
}

function _subscribeToNewsletter() {
  _subscribeToNewsletter = _asyncToGenerator(function* (context, email, optIn) {
    const {
      iso: locale
    } = context.state.i18n.currentLocale;
    const response = yield context.app.apolloProvider.defaultClient.mutate({
      mutation: subscribeToNewsletterMutation,
      variables: {
        email,
        optIn,
        locale
      }
    });
    return response.data;
  });
  return _subscribeToNewsletter.apply(this, arguments);
}

export { createUserAddress, deleteUserAddress, fetchUser, fetchUserProfile, fetchUserOrders, fetchUserBL, fetchUserOrder, fetchUserAddresses, fetchUserConsultedProducts, updateUserAddress, updateUserInformation, updateUserPassword, fetchDiscounts, updateUserOptin, subscribeToNewsletter };